import { BulkAction } from 'src/app/shared/interfaces'

import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core'
import { DataTable } from '@pascalhonegger/ng-datatable'

import { AppState } from '../../../core/core.state'
import { Store } from '@ngrx/store'
import { memberSelectors } from '../../member/member.selectors'
import { settingSelectors } from '../../../core/settings/settings.selectors'
import moment from 'moment-mini'
import { Moment } from 'moment-mini'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy'
import { combineLatest, Observable } from 'rxjs'
import { productSelectors } from '../../product/product.selectors'
import { Booking } from '../booking'
import { map, take } from 'rxjs/operators'
import { AccessRights } from '../../role/user-role/user-role'

@UntilDestroy()
@Component({
  selector: 'booking-review-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class BookingReviewTableComponent implements OnInit {
  @Input() tableData: Booking[] = []
  @Input() bulkActions: BulkAction[] = []
  @Input() total: number
  @Input() isModal: boolean = false
  @Input() showParent: boolean = true
  @Input() showPageFooter: boolean = false
  @Input() activePage: number = 1
  @Input() limitPage: number = 10
  @Input() pageCount: number
  @Input() showTotal: boolean = false
  @Input() removeSearchTerm$: Observable<boolean>
  @Output() onBulkAction = new EventEmitter<any>()
  @Output() onClickRow = new EventEmitter<any>()
  @Output() onSelectedPage = new EventEmitter<any>()
  @Output() onSelectLimit = new EventEmitter<any>()
  @Output() onSearchTerm = new EventEmitter<any>()
  @Output() onSave = new EventEmitter<any>()

  @ViewChild('dataTable', { static: true }) dataTable: DataTable
  public accessRights = AccessRights
  public onSaveClicked: boolean = false
  public mfRowsOnPage = 25
  public mfPages = 1
  public filterTerm: string = ''
  public allCheckedToggle: boolean = false
  public checkedIds: Map<number, boolean> = new Map()
  public productEntities$ = this.store.select(productSelectors.selectEntities)
  public memberEntities$ = this.store.select(memberSelectors.selectEntities)
  public selectedLanguage$ = this.store.select(
    settingSelectors.selectById,
    'language'
  )

  constructor(
    private store: Store<AppState>,
    private bsModalRef: BsModalRef,
    private modalService: BsModalService
  ) {}
  ngOnInit() {
    this.removeSearchTerm$?.pipe(untilDestroyed(this)).subscribe((remove) => {
      if (remove) {
        this.filterTerm = ''
      }
    })

    if (!this.showPageFooter) {
      setTimeout(() => {
        this.calculatePages()
      }, 1500)
    }
    if (this.tableData) {
      setTimeout(() => {
        this.allCheckedToggle = false
        this.onToggleAllChecked()
      }, 1000)
    }
  }

  public onClose() {
    this.bsModalRef.hide()
  }
  public onClickSave() {
    this.onSave.emit(this.checkedIds)
    this.onSaveClicked = true
    if (this.isModal) {
      this.bsModalRef.hide()
    }
  }
  public getDayOfWeek(starDate) {
    return moment(starDate).isoWeekday()
  }
  public getDescription(id) {
    return combineLatest([
      this.store.select(productSelectors.selectEntities)
    ]).pipe(
      take(1),
      map(([productEntities]) => productEntities[id].description)
    )
  }
  public onRowClicked(row: Booking) {
    this.onClickRow.emit(row)
  }

  public insertProductDescription(translation: string, productDesc) {
    return translation.replace('%', productDesc)
  }

  public onCheckRow(targetRow: Booking) {
    this.checkedIds.set(
      targetRow.id,
      !Boolean(this.checkedIds.get(targetRow.id))
    )
  }

  public onToggleAllChecked() {
    this.allCheckedToggle = !this.allCheckedToggle

    this.dataTable.data.forEach((row) =>
      this.checkedIds.set(row.id, this.allCheckedToggle)
    )
  }

  public onClickBulkAction(bulkOption: string) {
    const rows: Location[] = this.dataTable.data.filter((x) =>
      this.checkedIds.get(x.id)
    )

    if (rows.length > 0) {
      this.onBulkAction.emit({ action: bulkOption, items: rows })
    }
  }

  public onSearch(value) {
    if (this.showPageFooter) {
      this.onSearchTerm.emit(value)
    }
  }
  public selectPage(event) {
    if (this.pageCount >= this.activePage) this.onSelectedPage.emit(event)
  }
  public setNewSearh(event) {}
  public setSearchLimit(event) {
    this.onSelectLimit.emit(event)
  }

  public mfSelectPage(event) {
    this.dataTable.setPage(event, this.dataTable.rowsOnPage)
  }

  public mfSetSearchLimit(rowsOnPage) {
    let rowsOnPageChange: any = {
      currentValue: rowsOnPage,
      previousValue: this.dataTable.rowsOnPage
    }

    this.dataTable.ngOnChanges({ rowsOnPage: rowsOnPageChange })
    this.mfRowsOnPage = rowsOnPage
    this.calculatePages()
  }
  private calculatePages() {
    this.mfPages = Math.ceil(
      this.tableData?.length / this.dataTable?.rowsOnPage
    )
  }
}
